// Screens reachable without a session: sign-in, the password-reset flow, and
// the e-mail (un)subscribe landing pages. All of them face customers, so they
// use du — the register the rest of the customer product uses.
export const AUTH = {
  loginFailed:
    'Anmeldung nicht möglich. Bitte prüfe E-Mail-Adresse und Passwort.',
  forgotPassword: 'Passwort vergessen?',
  forgotPasswordTitle: 'Passwort zurücksetzen',
  forgotPasswordDescription:
    'Gib deine E-Mail-Adresse ein.\nDu erhältst einen Link zum Zurücksetzen deines Passworts.',
  sendResetLink: 'Link senden',
  resetLinkSent: 'Link gesendet',
  resetLinkSentDescription:
    'Falls ein Konto mit dieser E-Mail-Adresse existiert, wurde eine E-Mail mit Anweisungen zum Zurücksetzen des Passworts gesendet.',
  login: 'Anmelden',
  backToLogin: 'Zurück zur Anmeldung',
  resetPassword: 'Neues Passwort festlegen',
  resetPasswordDescription: 'Gib dein neues Passwort ein.',
  confirmPassword: 'Passwort bestätigen',
  passwordsDontMatch: 'Passwörter stimmen nicht überein',
  passwordTooShort: (min: number) =>
    `Passwort muss mindestens ${min} Zeichen lang sein`,
  passwordResetSuccess: 'Passwort erfolgreich geändert',
  passwordResetSuccessDescription:
    'Du kannst dich jetzt mit deinem neuen Passwort anmelden.',
  validatingToken: 'Token wird überprüft …',
  invalidResetToken: 'Ungültiger oder abgelaufener Link',
  invalidResetTokenDescription:
    'Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen. Bitte fordere einen neuen Link an.',
  requestNewLink: 'Neuen Link anfordern',
  unsubscribeTitle: 'E-Mail-Abmeldung',
  unsubscribeDescription:
    'Du bist dabei, unsere E-Mail-Benachrichtigungen abzubestellen.',
  unsubscribed: 'Erfolgreich abgemeldet',
  unsubscribeButton: 'Abbestellen',
  resubscribeTitle: 'E-Mails wieder erhalten',
  resubscribeDescription:
    'Möchtest du unsere E-Mail-Benachrichtigungen wieder erhalten?',
  resubscribed: 'Erfolgreich angemeldet',
  resubscribeButton: 'Erneut abonnieren',
  invalidToken: 'Ungültiger Link',
  invalidTokenDescription:
    'Der Link zur E-Mail-Abmeldung ist ungültig. Bitte wende dich an den Support.',
  currentStatus: 'Aktueller Status',
  subscribed: 'Abonniert',
  notSubscribed: 'Abbestellt',
} as const
